import QuotationHistoryCard
  from './QuotationHistoryCard';

interface Props {

  quotations: any[];

}

const QuotationHistoryList: React.FC<Props> = ({
  quotations,
}) => {

  return (

    <div className="space-y-3">

      {quotations.map((quotation) => (

        <QuotationHistoryCard
          key={quotation.id}
          quotation={quotation}
        />

      ))}

    </div>

  );

};

export default QuotationHistoryList;